import { LinearProgress } from "@material-ui/core";
import React, { useMemo } from "react";
import { useAuthContext } from "../../../providers/Auth/auth.provider";
import { AvailablePlatform } from "../../../providers/Auth/platform.provider";
import { CreateUserForm } from "../../components/user/create-user-form/create-user-form.component";
import {
  assignableAddressTypes,
  isRestrictedToWasteProducer,
} from "../../components/user/create-user-form/create-user-form.helper";
import { CreateUserFormProvider } from "../../components/user/create-user-form/create-user-form.provider";
import { AddressConverter } from "../../domain/converter/address.converter";
import { useGetUserAddresses } from "../../repositories/queries/address/get-user-addresses-for-id.query";

interface ICreateUserPageProps {
  platformType: AvailablePlatform;
}

export const CreateUserPage = ({ platformType }: ICreateUserPageProps) => {
  const { internalUser } = useAuthContext();
  // only waste producers on Cfm are limited to their own addresses, on Pom the form must not send any addresses
  const { isLoading, data: userAddresses } = useGetUserAddresses(
    internalUser?.id,
    assignableAddressTypes,
    undefined,
    isRestrictedToWasteProducer(internalUser, platformType) && internalUser?.id !== undefined,
  );

  // memoized, because the form resets the CFM user type whenever the addresses change
  const leanUserAddresses = useMemo(
    () => (userAddresses ? userAddresses.addresses.map(AddressConverter.domainToLeanAddressDomain) : []),
    [userAddresses],
  );

  return (
    <>
      {isLoading && <LinearProgress />}
      {!isLoading && (
        <CreateUserFormProvider user={internalUser} userAddresses={leanUserAddresses} platformType={platformType}>
          <CreateUserForm userAddresses={leanUserAddresses} />
        </CreateUserFormProvider>
      )}
    </>
  );
};
